import { createContext, useState } from "react"
//import * as poseDetection from "@tensorflow-models/pose-detection";


export const Context = createContext<any>(undefined)

// React 18 removed implicit children from React.FC, so it has to be declared.
const MyContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [taskId, setTaskId] = useState<string | null>(null)
  const [frontImgDone, setFrontImgDone] = useState(false)
  const [sideImgDone, setSideImgDone] = useState(false)
  const [frontMaskDone, setFrontMaskDone] = useState(false)
  const [sideMaskDone, setSideMaskDone] = useState(false)
  const [poses, setPoses] = useState<any>(null);


  const [orientation, setOrientation] = useState({ alpha: 0, beta: 0, gamma: 0 });


  let state = {
    taskId,
    setTaskId,
    frontImgDone,
    setFrontImgDone,
    sideImgDone,
    setSideImgDone,
    frontMaskDone,
    setFrontMaskDone,
    sideMaskDone,
    setSideMaskDone,
    orientation,
    setOrientation,
    poses,
    setPoses,
  }

  return (
    <Context.Provider value={state}>
      {children}
    </Context.Provider>
  )
}

export default MyContextProvider;
